import { PlusOutlined } from '@ant-design/icons';
import { css, styled } from '@aibi-ui/core';
import { Button } from 'antd';
import React from 'react';
import IconCollapse from '@gainer-ui/ai-bi-chat/assets/icons/chat-collapsed.svg';
import IconUnCollapse from '@gainer-ui/ai-bi-chat/assets/icons/chat-uncollapsed.svg';

const StyledAddButton = styled(Button)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 8px;
  height: 38px;
  line-height: 34px;
  background: rgba(86, 135, 255, 0.1);
  border-radius: 6px;
  border: 1px solid rgba(86, 135, 255, 0.3);
  font-size: 12px;
  color: #5687ff;
  font-weight: 400;
  &:hover,
  &:focus {
    background: rgba(86, 135, 255, 0.2);
    color: #5687ff;
  }
`;

const CollapseIcon: React.FC<{ collapse: boolean; toggle: () => void }> = ({
  collapse,
  toggle,
}) => {
  return (
    <div
      className="w-[38px] h-[38px] flex items-center justify-center cursor-pointer"
      onClick={toggle}
      css={css`
        svg {
          color: #909aaa;
          fill: none;
          width: 16px;
          height: 16px;
        }
      `}
    >
      {collapse ? (
        <IconCollapse viewBox="0 0 16 16" />
      ) : (
        <IconUnCollapse viewBox="0 0 16 16" />
      )}
    </div>
  );
};

const ReportChatHistory: React.FC<{
  collapse: boolean;
  toggleCollapse: () => void;
  handleCreateConversation: () => void;
  children: React.ReactNode | React.ReactNode[];
}> = ({ collapse, toggleCollapse, handleCreateConversation, children }) => {
  return (
    <div className="h-full overflow-auto flex flex-col">
      {collapse ? (
        <div className="flex gap-[15px] items-center px-[16px] pt-[16px]">
          <StyledAddButton
            type="primary"
            block
            icon={<PlusOutlined />}
            onClick={handleCreateConversation}
          >
            新对话
          </StyledAddButton>
          <CollapseIcon collapse={collapse} toggle={toggleCollapse} />
        </div>
      ) : (
        <CollapseIcon collapse={collapse} toggle={toggleCollapse} />
      )}
      {collapse && (
        <div className="my-[15px] border-b-[1px] border-b-[#D2D2D2] mx-[16px]"></div>
      )}
      <div
        className={[
          'flex-1 flex flex-col overflow-auto',
          collapse ? 'opacity-100' : 'opacity-0',
        ].join(' ')}
      >
        {children}
      </div>
    </div>
  );
};

export default ReportChatHistory;
